import * as qs from 'qs'
import { ReportStatusGroupKey } from 'src/features/monitoringDashboardAlpha/types'

/** モニタリングダッシュボード詳細（L2）のルートパス */
export const monitoringDashboardDetailPath = '/monitoringDashboardAlpha/detail'

/**
 * L1 から L2 への遷移先パス（クエリ付き）を組み立てる
 *
 * - 日付範囲は常に引き継ぐ
 * - status / placeNodeUuids は遷移元（カード / セル）に応じて付与する
 *   - サマリーカード: L1 で絞り込んでいる現場（filters.placeNodeUuids）をそのまま引き継ぐ
 *   - 件数セル: クリックした行の現場 1件のみ
 */
export const buildDetailPath = ({
  dateRange,
  placeNodeUuids,
  status,
}: {
  dateRange: [string, string] | null
  placeNodeUuids?: string[]
  status?: ReportStatusGroupKey | null
}): string => {
  const query = qs.stringify(
    {
      dateRange: dateRange ?? undefined,
      placeNodeUuids: placeNodeUuids?.length ? placeNodeUuids : undefined,
      status: status ?? undefined,
    },
    { skipNulls: true, encode: false },
  )
  return query
    ? `${monitoringDashboardDetailPath}?${query}`
    : monitoringDashboardDetailPath
}
